import React from "react";
import AboutDriveImage1 from "../../assets/img/aboutt-hero.jpg";
import "../WhatDrivesUs.css";

export default function WhatDrivesUs() {
  return (
    <section className="wd-fullbleed">
      <img src={AboutDriveImage1} alt="Care Team" />
    </section>
  );
}
